<div class="card mb-4 mx-0 mx-sm-4">
  <div class="card-body p-0" [class.placeholder-glow]="isLoading()">
    <!-- Two Column Layout: Image (Left) | Info (Right) -->
    <div class="row g-0">
      <!-- Left Half: Property Image -->
      <div class="col-12 col-md-6">
        <div class="property-image-container">
          @if (isLoading()) {
            <div class="placeholder w-100 h-100"></div>
          } @else {
            <img
              src="/ms/images/property-profile-placeholder.png"
              alt="Property Image"
              class="property-image"
            />
          }
        </div>
      </div>

      <!-- Right Half: Property Information -->
      <div class="col-12 col-md-6">
        <div class="property-info-container">
          <div class="property-header-row">
          <!-- Property Details -->
          <div class="property-details">
            @if (isLoading()) {
              <div class="placeholder col-10 mb-2"></div>
              <div class="placeholder col-8"></div>
            } @else {
              @if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(property()?.title) &&
                (property()?.addresses?.length ?? 0) < 1 &&
                CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(property()?.lotNumber)) {
                <div class="fs-5 fst-italic ">
                  No property information available.
                </div>
              } @else if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(property()?.title) &&
                (property()?.addresses?.length ?? 0) < 1) {
                <div class="fs-5 fw-bold text-truncate" [msTooltip]="property()?.lotNumber ?? ''" msTooltipOnlyIfTruncated>
                  {{property()?.lotNumber}}
                </div>
              } @else if (CommonChecks.isNullOrUndefinedOrEmptyOrWhitespace(property()?.title)) {
                <div class="fs-5 fw-bold property-address" [msTooltip]="addressTooltip()" msTooltipOnlyIfTruncated>
                  <span [innerHTML]="property()?.addresses?.[0] | Address:AddressPipeSecondaryAddressFormat.NewLine | SafeHtml"></span>
                </div>
                <div class="fs-5 mt-2 text-truncate" [msTooltip]="property()?.lotNumber ?? ''" msTooltipOnlyIfTruncated>
                  {{property()?.lotNumber}}
                </div>
              } @else {
                <div class="fw-bold fs-3 mb-2 property-title"
                     msAutoFitText [msAutoFitMinFontSize]="20" [msAutoFitMaxLines]="2"
                     [msTooltip]="property()?.title || ''" msTooltipOnlyIfTruncated>
                  {{property()?.title}}
                </div>
                <div class="fs-5 property-address" [msTooltip]="addressTooltip()" msTooltipOnlyIfTruncated>
                  <span [innerHTML]="property()?.addresses?.[0] | Address:AddressPipeSecondaryAddressFormat.NewLine | SafeHtml"></span>
                </div>
                <div class="fs-5 text-truncate" [msTooltip]="property()?.lotNumber ?? ''" msTooltipOnlyIfTruncated>
                  {{property()?.lotNumber}}
                </div>
                <div class="fs-5 text-truncate"
                     [msTooltip]="property()?.addresses?.[0]?.country?.name ?? ''" msTooltipOnlyIfTruncated>
                  {{property()?.addresses?.[0]?.country?.name}}
                </div>
              }
              @if (property()?.status) {
                <div class="mt-2">
                  <ms-status-badge [status]="property()!.status" [isLoading]="isLoading()" />
                </div>
              }
            }
          </div>

          <!-- Actions Button -->
          <!-- Gated on the whole container so that a viewer with neither properties.update nor
               properties.status nor properties.delete never sees the dropdown at all (DEV-2576). The
               individual items are then permission-gated so each only renders when its own policy
               is held. -->
          <div class="actions-container" *ifHasPermission="{
              requiredPermissions: [PropertyPermission.Update, PropertyPermission.Status, PropertyPermission.Delete],
              userPermissionOnly: false
            }">
            <div class="dropdown">
              <button class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" [class.placeholder]="isLoading()">
                <span>Actions</span>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update], userPermissionOnly: false }">
                  <a class="dropdown-item"
                    [class.disabled]="isDeleted()"
                    [attr.aria-disabled]="isDeleted() ? 'true' : null"
                    [attr.tabindex]="isDeleted() ? -1 : null"
                    (click)="!isDeleted() ? editRequested.emit() : $event.stopPropagation()">
                    <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="me-2" />Edit</a>
                </li>
                @if (isDeactivated()) {
                  <li *ifHasPermission="{ requiredPermissions: [PropertyPermission.Status], userPermissionOnly: false }">
                    <a class="dropdown-item" (click)="reactivateRequested.emit()">
                      <fa-duotone-icon icon="circle-check" class="me-2" />Reactivate</a>
                  </li>
                } @else {
                  <li *ifHasPermission="{ requiredPermissions: [PropertyPermission.Status], userPermissionOnly: false }">
                    <a class="dropdown-item"
                      [class.disabled]="isDeleted()"
                      [attr.aria-disabled]="isDeleted() ? 'true' : null"
                      [attr.tabindex]="isDeleted() ? -1 : null"
                      (click)="!isDeleted() ? deactivateRequested.emit() : $event.stopPropagation()">
                      <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Deactivate</a>
                  </li>
                }
                <li *ifHasPermission="{ requiredPermissions: [PropertyPermission.Delete], userPermissionOnly: false }">
                  <a class="dropdown-item"
                    [class.disabled]="isDeleted()"
                    [attr.aria-disabled]="isDeleted() ? 'true' : null"
                    [attr.tabindex]="isDeleted() ? -1 : null"
                    (click)="!isDeleted() ? deleteRequested.emit() : $event.stopPropagation()">
                    <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete</a>
                </li>
              </ul>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Navigation Tabs - Full Width Bottom -->
  <div class="profile-nav-container">
    <ms-responsive-tabs [navItems]="navItems() ?? []" (tabChanged)="onTabClick($event)" />
  </div>
</div>
